export const ADMIN_ACTIONS = {
  TRIAL_EXTENDED: 'TRIAL_EXTENDED',
  PLAN_OVERRIDDEN: 'PLAN_OVERRIDDEN',
  DISCOUNT_APPLIED: 'DISCOUNT_APPLIED',
  NOTES_UPDATED: 'NOTES_UPDATED',
  PROMO_CREATED: 'PROMO_CREATED',
  PROMO_DEACTIVATED: 'PROMO_DEACTIVATED',
  MAINTENANCE_MODE_TOGGLED: 'MAINTENANCE_MODE_TOGGLED',
  FEATURE_FLAG_TOGGLED: 'FEATURE_FLAG_TOGGLED',
  BROADCAST_SMS_QUEUED: 'BROADCAST_SMS_QUEUED',
  GST_MASTER_VERSION_UPDATED: 'GST_MASTER_VERSION_UPDATED',
  ADMIN_ADDED: 'ADMIN_ADDED',
  ADMIN_REMOVED: 'ADMIN_REMOVED',
  PLATFORM_WEBHOOK_UPDATED: 'PLATFORM_WEBHOOK_UPDATED',
  PLATFORM_WEBHOOK_SECRET_REGENERATED: 'PLATFORM_WEBHOOK_SECRET_REGENERATED',
  PLATFORM_WEBHOOK_TEST_SENT: 'PLATFORM_WEBHOOK_TEST_SENT',
  APPROVAL_REQUESTED: 'APPROVAL_REQUESTED',
  APPROVAL_APPROVED: 'APPROVAL_APPROVED',
  APPROVAL_REJECTED: 'APPROVAL_REJECTED',
  ADMIN_TASK_CANCELLED: 'ADMIN_TASK_CANCELLED',
  ADMIN_TASK_RETRIED: 'ADMIN_TASK_RETRIED',
  GST_DRAFT_CREATED: 'GST_DRAFT_CREATED',
  GST_VERSION_PUBLISH_REQUESTED: 'GST_VERSION_PUBLISH_REQUESTED',
  GST_VERSION_ROLLBACK_REQUESTED: 'GST_VERSION_ROLLBACK_REQUESTED',
  PLAN_CONFIG_DRAFTED: 'PLAN_CONFIG_DRAFTED',
  PLAN_CONFIG_PUBLISH_REQUESTED: 'PLAN_CONFIG_PUBLISH_REQUESTED',
  PRODUCT_CONFIG_DRAFTED: 'PRODUCT_CONFIG_DRAFTED',
  API_KEY_CREATED: 'API_KEY_CREATED',
  API_KEY_REVOKED: 'API_KEY_REVOKED',
};
